import { UserSummary } from '../administration/user';
import { StockItemSummary } from './item';
import { LocationSummary } from './location';

export class StockLocationMinMax{
 // id : number;
  stockItemId: number;
  stockItem: StockItemSummary;
  locationId: number;
  location: LocationSummary;
  locatedAt: string;
  productExpiration: Date;
  emailNotifyUserId: string;
  emailNotifyUser: UserSummary;
  smsNotifyUserId: 0;
  smsNotifyUser: UserSummary;
  minQty: number;
  maxQty: number;

  constructor(){
    this.stockItemId = 0;
    this.stockItem = null;
    this.locationId = 0;
    this.location = null;
    this.locatedAt = '';
    // this.productExpiration = new Date();
    this.emailNotifyUserId = "";
    this.emailNotifyUser = null;
    this.smsNotifyUserId = 0;
    this.smsNotifyUser = null;
    this.minQty = 0;
    this.maxQty = 0;
  }
}

